import React, { useContext, useEffect } from 'react';
import styles from './SearchBar.module.scss';

import SearchBarSpecialtySelect from './search-bar-specialty-select/SearchBarSpecialtySelect';
import SearchBarReportYearSelect from './search-bar-report-year-select/SearchBarReportYearSelect';
import SearchBarCriteriaInput from './search-bar-criteria-input/SearchBarCriteriaInput';
import SearchBarLocationInput from './search-bar-location-input/SearchBarLocationInput';
import SearchKeyWordInput from './search-bar-key-word-input/SearchBarKeyWordInput';
import SearchBarButton from './search-bar-button/SearchBarButton';
import SearchBarPCPSelect from './search-bar-pcp-select/SearchBarPCPSelect';
import SearchBarDistanceSelect from './search-bar-distance-select/SearchBarDistanceSelect';

import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';

const SearchBar = () => {
  const appContext = useContext(AppContext);

  useEffect(() => {
    // reserved for future logic
  }, [appContext.search]);

  const isDirectoryMode =
    appContext.isDirectorySelected &&
    appContext.directoryListType !== DirectoryListType.none &&
    appContext.directoryListType !== DirectoryListType.all;

  const isKeywordMode =
    appContext.isDirectorySelected &&
    appContext.directoryListType === DirectoryListType.all;

  return (
    <>
      {isDirectoryMode && (
        <div
  className={
  appContext.directoryListType === DirectoryListType.doctor
    ? styles.searchBarDoctor
    : appContext.directoryListType === DirectoryListType.pharmacy
    ? styles.searchBarPharmacy
    : styles.searchBarDefault
}
>

         <SearchBarSpecialtySelect />

{appContext.directoryListType === DirectoryListType.pharmacy && (
  <SearchBarReportYearSelect />
)}

{appContext.directoryListType === DirectoryListType.doctor && (
  <SearchBarPCPSelect />
)}

<SearchBarCriteriaInput />
          <SearchBarLocationInput />
          <SearchBarDistanceSelect />

          <SearchBarButton />

        </div>
      )}

      {isKeywordMode && (
        <div className={styles.keywordSearchBar}>
          <SearchKeyWordInput />
          <SearchBarButton />
        </div>
      )}
    </>
  );
};

export default SearchBar;